// NGRX
import { createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
// Actions

// Models
import { PatientImageChangeRequest } from '../_models/patient-image-change-request.model';
import { QueryParamsModel } from '../../_base/crud';
import {
  ClearPatienImageChangeRequesttErrors,
  FirePatientImageChangeRequestSuccess,
  PatientImageChangeRequestActionToggleLoading,
  PatientsImageChangeRequestPageCancelled,
  PatientsImageChangeRequestPageToggleLoading,
  PatientsImageChangeRequestsPageLoaded,
  ThrowPatientImageChangeRequestError,
} from '../_actions/patient-image-change-request.actions';

export interface PatientImageChangeRequestState extends EntityState<PatientImageChangeRequest> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastQuery: QueryParamsModel;
  showInitWaitingMessage: boolean;
  latestSuccessfullAction: any;
  error: any | null;
}

export const adapter: EntityAdapter<PatientImageChangeRequest> =
  createEntityAdapter<PatientImageChangeRequest>();

export const initialPatientImageChangeRequestState: PatientImageChangeRequestState =
  adapter.getInitialState({
    listLoading: false,
    actionsloading: false,
    totalCount: 0,
    lastQuery: new QueryParamsModel({}),
    showInitWaitingMessage: true,
    error: null,
    latestSuccessfullAction: null,
  });

const _patientImageChangeRequestsReducer = createReducer(
  initialPatientImageChangeRequestState,
  on(PatientsImageChangeRequestPageToggleLoading, (state, { isLoading }) => ({
    ...state,
    listLoading: isLoading,
  })),
  on(PatientImageChangeRequestActionToggleLoading, (state, { isLoading }) => ({
    ...state,
    actionsloading: isLoading,
  })),
  on(PatientsImageChangeRequestPageCancelled, (state) => ({
    ...state,
    listLoading: false,
    lastQuery: new QueryParamsModel({}),
  })),
  on(PatientsImageChangeRequestsPageLoaded, (state, { totalCount, page, requests }) =>
    adapter.addMany(requests, {
      ...initialPatientImageChangeRequestState,
      totalCount: totalCount,
      listLoading: false,
      lastQuery: page,
      showInitWaitingMessage: false,
    }),
  ),
  on(ThrowPatientImageChangeRequestError, (state, { error }) => ({
    ...state,
    error: error,
    actionsloading: false,
    listLoading: false,
  })),
  on(ClearPatienImageChangeRequesttErrors, (state) => ({
    ...state,
    error: null,
  })),
  on(FirePatientImageChangeRequestSuccess, (state, { action_type }) => ({
    ...state,
    latestSuccessfullAction: { action_type },
    error: null,
  })),
);

export function patientImageChangeRequestsReducer(state, action) {
  return _patientImageChangeRequestsReducer(state, action);
}
